module.exports = __webpack_public_path__ + "static/yoy-58e14aaabfdbd7a0f3c12565c4086007.jpg";